import { Disposer } from './Disposer';

export const EmptyDisposer: Disposer = () => {};
